import React, { useCallback, useRef } from 'react';

//Hooks
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

//Actions
import { updateAvatar, logout } from '../../../store/actions';

//Components
import { Image } from 'react-bootstrap'
import Icon from '../../../components/Icon/Icon';
import ButtonWithIcon from '../../../components/ui/ButtonWithIcon/ButtonWithIcon';

//Styles
import Styles from './MyProfile.module.scss';
import Loader from 'react-loader-spinner'

//Utils
import { version } from '../../../../package.json';
import { ROUTER_URL } from '../../../const/ROUTER_URL';
import { LOCALE_NAMESPACE } from '../../../const/translations/LOCALE_NAMESPACE';

const MyProfile = () => {
    const profile = useSelector(state => state.profile.profile);
    const loyaltyProgramEnabled = useSelector(state => state.companies.selectedCompany.company.enable_loyalty_program);
    const dispatch = useDispatch();

    const ref = useRef(null);

    const history = useHistory();
    const { t } = useTranslation(LOCALE_NAMESPACE.COMMON);

    const handleSubmit = useCallback((event) => {
        event.preventDefault();
        dispatch(updateAvatar(ref.current.files[0]))
    }, [dispatch]);

    const handleProfileLoyaltyRedirect = useCallback(() => {
        history.push(ROUTER_URL.PROFILE_LOYALTY);
    }, [history]);

    const handleProfileAccountRedirect = useCallback(() => {
        history.push(ROUTER_URL.PROFILE_ACCOUNT);
    }, [history]);

    const handleProfileSettingsRedirect = useCallback(() => {
        history.push(ROUTER_URL.PROFILE_SETTINGS);
    }, [history]);

    const handleLogout = useCallback(() => {
        dispatch(logout())
    }, [dispatch]);

    if (!profile) {
        return (
            <div className={Styles.container}>
                <Loader type="TailSpin" color="#000" height={40} width={40}/>
            </div>
        )
    }

    return (
        <>
            <div className={Styles.container}>
                <label className={Styles.imageContainer}>
                    <div className={Styles.fileInput}>
                        <form>
                            <input
                                className={Styles.fileInput}
                                data-testid="avatarInput"
                                ref={ref}
                                onChange={handleSubmit} type="file" accept="image/*"
                            />
                        </form>
                    </div>
                    <Image
                        className={Styles.img}
                        roundedCircle
                        src={profile.avatar}
                    />
                    <label className={Styles.editButton}>
                        <Icon name="pen" size={20} color="#fff"/>
                    </label>
                </label>
                <p className={Styles.userName} data-testid="data-test-userName">
                    {profile.firstName + " " + profile.lastName}
                </p>
                <div className={Styles.loyaltyContainer}>
                    {loyaltyProgramEnabled && (
                        <button
                            data-testid="data-testid-profile-button-loyaltyButton"
                            className={Styles.infoButtons}
                            onClick={handleProfileLoyaltyRedirect}
                        >
                            <Icon name="gift" color="#000" size={17} className={Styles.icon}/>
                            {t('myProfile.points', { count: profile.loyaltyPoints })}
                        </button>
                    )}
                </div>
                <ButtonWithIcon
                    data-testid="data-testid-profile-button-editButton"
                    navigateHandler={handleProfileAccountRedirect}
                    iconName="edit"
                >
                    {t('myProfile.editAccount.title')}
                </ButtonWithIcon>
                <ButtonWithIcon
                    data-testid="data-testid-profile-button-settingsButton"
                    navigateHandler={handleProfileSettingsRedirect}
                    iconName="cog"
                >
                    {t('myProfile.settings.title')}
                </ButtonWithIcon>
                <ButtonWithIcon
                    data-testid="data-testid-profile-button-logoutButton"
                    navigateHandler={handleLogout}
                    iconName="sign-out"
                >
                    {t('myProfile.logout')}
                </ButtonWithIcon>
                <span className={Styles.version}>
                    {t('version', { version })}
                </span>
            </div>
        </>
    )
}

export default MyProfile
